module.exports = __webpack_public_path__ + "media/images/top/common/img_qa-dc6229943a90317afbcb180703a1576f.png";